import { Injectable, signal, computed } from '@angular/core';

interface ICssValues {
    lineHeight: number;
    imageRowHeight: number;
}

const cssVar = {
    lineHeight: '--shape-tablist-line-height',
    imageRowHeight: '--shape-tablist-image-row-height',
} as const;

const fallback: ICssValues = {
    lineHeight: 25,
    imageRowHeight: 66,
};

@Injectable({
    providedIn: 'root'
})
export class CssVariablesService {
    private __values$$ = signal<ICssValues>(this.__read());

    lineHeight$$ = computed(() => this.__values$$().lineHeight);
    imageRowHeight$$ = computed(() => this.__values$$().imageRowHeight);

    constructor() {
        window.addEventListener('resize', this.__onResize, { passive: true });
    }

    private __onResize = (() => {
        let __timer: number | null = null;
        return () => {
            if (__timer !== null) window.clearTimeout(__timer);
            __timer = window.setTimeout(() => this.__values$$.set(this.__read()), 50);
        };
    })();

    private __read(): ICssValues {
        const __style = getComputedStyle(document.documentElement);
        return {
            lineHeight: this.__parsePx(__style.getPropertyValue(cssVar.lineHeight)) ?? fallback.lineHeight,
            imageRowHeight: this.__parsePx(__style.getPropertyValue(cssVar.imageRowHeight)) ?? fallback.imageRowHeight,
        };
    }

    private __parsePx(value: string): number | null {
        const __n = parseFloat(value);
        return Number.isFinite(__n) ? __n : null;
    }
}
